import { ParamsAdapter } from './params-adapter';

export class DefaultParams extends ParamsAdapter {
  constructor(private attributes: object = {}) {
    super();
  }

  getParams(): object {
    return this.attributes;
  }
}
